import { Icon, Step } from "semantic-ui-react";

require("./PickUpStepper.css");

interface PickUpStepperProps {
  step: number;
  pickUpDate?: string;
  pickUpTime?: string | null;
}

const PickUpStepper = (props: PickUpStepperProps) => {
  return (
    <div>
      <Step.Group unstackable>
        <Step active={props.step === 1}>
          <Icon name="calendar alternate" />
          <Step.Content className="mobile hidden">
            <Step.Title>Choose date</Step.Title>
            <Step.Description>When can you pick up the car?</Step.Description>
          </Step.Content>
        </Step>

        <Step active={props.step === 2} disabled={!props.pickUpDate}>
          <Icon name="time" />
          <Step.Content className="mobile hidden">
            <Step.Title>Choose pick up time</Step.Title>
            <Step.Description>Select a time</Step.Description>
          </Step.Content>
        </Step>

        <Step active={props.step === 3} disabled={!props.pickUpTime}>
          <Icon name="save" />
          <Step.Content className="mobile hidden">
            <Step.Title>Confirm Pick Up</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    </div>
  );
};

export default PickUpStepper;
